module.exports = __webpack_public_path__ + "static/img/Mampamm_thumb.61e6363.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/Mampamm_thumb.svg
// module id = VmBl
// module chunks = 4